export default "__VITE_ASSET__CGSYR60n__"